import {Col, Container, Row, Spinner} from "react-bootstrap";

const Loader2 = ({
                    style = {},
                    message
                } = {}) => {
    return (
        <Container
            fluid
            className="w-100 d-flex" style={{height: '30vh', ...style}}>
            <Row className="m-auto w-100">
                <Col className="d-flex flex-column gap-3 justify-content-center align-items-center">
                    <Spinner
                        animation="border"
                        variant="primary"
                        className="m-auto"
                        style={{
                            padding: '0px',
                            width: '2rem',
                            height: '2rem',
                        }}/>
                    <span className="mx-auto">{message}</span>
                </Col>
            </Row>
        </Container>
    )
};

export default Loader2;
